import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import Offcanvas from "react-bootstrap/Offcanvas";

import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import Validation from "../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../common/Button";

import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { getData } from "../../../../utils/api";
import Select from "react-select";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData } = useContext(Context);
  const [productCategory, setProductCategory] = useState([]);
  const [productSubCategory, setProductSubCategory] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    margin_price: "",
    net_weight: "",
    hsn_code: "",
    // quantity: "",
    product_category_id: "",
    product_sub_category_id: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const handleChange = (e) => {
    // CATEGORY
    if (e?.name === "product_category_id") {
      setFormData((prev) => ({
        ...prev,
        product_category_id: e,
        product_sub_category_id: "",
        name: "",
      }));

      getSelectedProductSubCategory(e.value);
    }

    // SUB CATEGORY → AUTO SET PRODUCT NAME
    else if (e?.name === "product_sub_category_id") {
      const categoryName = formData.product_category_id?.label || "";
      const subCategoryName = e.label || "";

      setFormData((prev) => ({
        ...prev,
        product_sub_category_id: e,
        name: `${categoryName} - ${subCategoryName}`, // 🔥 HERE
      }));
    }

    // INPUT FIELDS
    else {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  async function getSelectedProductSubCategory(id) {
    const response = await getData(`/masters/allproductsubcategory/${id}`);

    if (response.success) {
      setProductSubCategory(response.data);
    }
  }

  const GetAllProductCategory = async () => {
    const response = await getData("/masters/allproductCategory");

    const option = [];
    if (response.success) {
      response?.data?.map((data) => {
        option.push({
          value: data.id,
          name: "product_category_id",
          label: data.name,
        });
      });
    }
    setProductCategory(option);
  };

  useEffect(() => {
    GetAllProductCategory();
  }, []);

  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    let newErrors = {};

    if (!formData.product_category_id?.value) {
      newErrors.product_category_id = "Product category is required";
    }

    if (!formData.product_sub_category_id?.value) {
      newErrors.product_sub_category_id = "Product sub category is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    // existing validation
    const validationErrors = await Validation.FormValidation({
      classname: ".productlistclass",
    });

    if (validationErrors) {
      try {
        const response = await postData(
          "/product_management/product_list",
          formData
        );
        if (response.success) {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        } else {
          setShowModal({ code: response.code, message: response.message });
          setTimeout(() => {
            setShowModal(0);
            props.handleClose();
          }, 1000);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const handleKeyPressContact = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    if (!/^\d*\.?\d*$/.test(keyValue)) {
      event.preventDefault();
    }
  };

  const errorStyle = {
    color: "red",
    marginLeft: "5px",
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}>
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add Education_List</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>Add Product </Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={handleSubmit}
                            role="form"
                            className="productlistclass">
                            <Row>
                              <Col
                                lg={12}
                                md={12}
                                className=" mx-auto Add-content">
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label column sm={3}>
                                          Select Product Category{" "}
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            name="product_category_id"
                                            onChange={(option) =>
                                              handleChange({
                                                ...option,
                                                name: "product_category_id",
                                              })
                                            }
                                            value={formData.product_category_id}
                                            options={productCategory}
                                          />

                                          {errors.product_category_id && (
                                            <span className="error-message">
                                              {errors.product_category_id}
                                            </span>
                                          )}
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label column sm={3}>
                                          Select Product SubCategory{" "}
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Select
                                            name="product_sub_category_id"
                                            onChange={(option) =>
                                              handleChange({
                                                ...option,
                                                name: "product_sub_category_id",
                                              })
                                            }
                                            value={
                                              formData.product_sub_category_id
                                            }
                                            options={productSubCategory.map(
                                              (d) => ({
                                                value: d.id,
                                                label: d.name,
                                              })
                                            )}
                                          />

                                          {errors.product_sub_category_id && (
                                            <span className="error-message">
                                              {errors.product_sub_category_id}
                                            </span>
                                          )}
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Product
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                placeholder="Product"
                                                className="input-mandatory"
                                                disabled
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>

                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Price
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="price"
                                                value={formData.price}
                                                onChange={handleChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Price "
                                                id="inputEmail3"
                                                // className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Margin Price
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="margin_price"
                                                value={formData.margin_price}
                                                onChange={handleChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Margin Price "
                                                id="inputEmail3"
                                                // className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          Net Weight(grams)
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="tel"
                                                name="net_weight"
                                                value={formData.net_weight}
                                                onChange={handleChange}
                                                onKeyPress={
                                                  handleKeyPressContact
                                                }
                                                placeholder="Net Weight(grams) "
                                                id="inputEmail3"
                                                // className="input-mandatory"
                                              />
                                            </InputGroup>
                                            {/* <span className="error-message"></span> */}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-5">
                                      <Row className="justify-content-center">
                                        <Form.Label column sm={3}>
                                          HSN Code
                                        </Form.Label>
                                        <Col sm={6}>
                                          <Form.Group>
                                            <InputGroup>
                                              <Form.Control
                                                type="text"
                                                name="hsn_code"
                                                value={formData.hsn_code}
                                                onChange={handleChange}
                                                placeholder="HSN Code"
                                                id="inputEmail3"
                                                className="input-mandatory"
                                              />
                                            </InputGroup>
                                            <span className="error-message"></span>
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
